import { useIntl } from 'react-intl';

import { CAREER_HUB_BASE_PATH } from '@xing-com/crate-career-hub-common';
import { IconArrowLeft } from '@xing-com/icons';

import { Styled } from './back-button.styles';

export const BackButton: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Styled.TextButton
      icon={IconArrowLeft}
      to={`${CAREER_HUB_BASE_PATH}/bewerbung-uebersicht`}
    >
      {formatMessage({
        id: 'CAREER_HUB_EVERGREEN_BACK_BUTTON',
      })}
    </Styled.TextButton>
  );
};
